import { Injectable } from '@angular/core'

import { HttpClient } from '../_services/global-http.service';
import { HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {map} from 'rxjs/operators';

import {ITrackerPaginationApi} from '../_models/tracker';
import { PaginationParams } from '../_models/generic';
import { Utilities } from '../_utilities/Utilities';

@Injectable()
export class TrackerService {
  constructor (private http: HttpClient) {}

  findAdminTrackers(params: PaginationParams):  Observable<ITrackerPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<ITrackerPaginationApi>('/api/vehicles_trackers/',  {params: _params});
  }

  findTrackersMultiSelect(params: PaginationParams):  Observable<ITrackerPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<ITrackerPaginationApi>('/api/administration/trackers_list/',  {params: _params});
  }

  getRawTrackerDataForVehicle(trackerID, startDateTime, endDateTime){//, params: PaginationParams){
    // const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<ITrackerPaginationApi>('/api/administration/raw_vehicle_data/?tracker_id='+trackerID+'&start='+startDateTime+'&end='+endDateTime);//,  {params: _params});
  }

  getTrackers() {
    return this.http.get(`/api/vehicles_trackers/`);
  }

  postAddTracker(newTracker: any){
    return this.http.post('/api/vehicles_trackers/', newTracker);
  }

  putUpdateTracker(updateTracker: any, id: number) {
    return this.http.put('/api/vehicles_tracker/'+id+'/', updateTracker);
  }

  removeTracker(id: any) {
    return this.http.post('/api/users_delete/', id)
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/trackers.service.ts